module.exports = __webpack_public_path__ + "img/27.ca453dc6.jpg";